import { AppServices } from "./AppServices";

interface CouponAbuse {
   checkTime: number;
   count: number;
}

export class CouponController {
   private appServices_ = new AppServices();
   constructor(appServices: AppServices) {
      this.appServices_ = appServices;
   }

   private load(): CouponAbuse | undefined {
      const json = sessionStorage.getItem('coupon-check');
      if (!json) return undefined;
      try {
         return <CouponAbuse>JSON.parse(json);
      } catch {

      }
      return undefined;
   }
   private save(data?: CouponAbuse): void {
      if (!data) {
         sessionStorage.removeItem('coupon-check');
      } else {
         const json = JSON.stringify(data);
         sessionStorage.setItem('coupon-check', json);
      }
   }

   private registerInvalidCoupon(): void {
      let data = this.load();
      if (!data) {
         data = {
            checkTime: Date.now(),
            count: 1
         };         
      } else {
         data.checkTime = Date.now();
         data.count++;
      }
      this.save(data);
   }

   public validate(event: Event): boolean {
      const data = this.load();
      //console.log(data);
      if (data) {
         const time = Date.now() - data.checkTime;
         if (time < 3000 && data.count > 2) {
            event.preventDefault();
            event.stopPropagation();

            const btn = event.currentTarget as HTMLButtonElement | HTMLInputElement;
            btn.disabled = true;

            const wait = Math.min(15000, 2000 + data.count * 1000);

            setTimeout(() => {
               btn.disabled = false;               
               btn.click();
            }, wait);

            return false;
         }
      }
      return true;
   }
   public onLoad(): void {
      const elCheck = document.getElementById('invalid-coupon') as HTMLFormElement | null;
      if (elCheck) {
         this.registerInvalidCoupon();
         //console.log('bad coupon');
      } else {
         const form = document.getElementById('coupon-form');
         if (!form) {
            this.save(undefined);
            //console.log('clear bad coupon');
         }
      }
   }
}